/**
 * Gets the last date of a given month and year.
 * @param month - 1-indexed month (1 = January, 12 = December)
 * @param year - Full year (e.g., 2024)
 * @returns Formatted date string as "M/DD/YYYY"
 */
export const getLastDateOfMonth = (month: number, year: number): string => {
  // Convert 1-indexed month to 0-indexed for JavaScript Date constructor
  // JavaScript Date uses 0-indexed months (0 = January, 11 = December)
  const lastDay = new Date(year, month - 1, 0).getDate();
  return `${month}/${lastDay}/${year}`;
};
